import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { appRoutes } from 'config';
import heroProductPreview from 'assets/images/hero-product-preview.png';
import { CtaButton } from './components/CtaButton';
import { PlatformRow } from './components/PlatformRow';

const WebGlyph = () => (
  <svg viewBox="0 0 24 24">
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18" />
  </svg>
);

// Download page — MindFeed for Web.
export const Section36 = () => {
  const t = useTranslations();
  return (
    <PlatformRow
      id="web"
      label={t('pages.download.web.label')}
      icon={<WebGlyph />}
      tag={t('pages.download.web.tag')}
      title={t('pages.download.web.title')}
      description={t('pages.download.web.description')}
      features={[
        t('pages.download.web.feature1'),
        t('pages.download.web.feature2'),
        t('pages.download.web.feature3'),
      ]}
      actions={
        <CtaButton
          variant="primary"
          href={appRoutes.LOGIN}
          reportLocation="Download Web"
          withArrow
          newTab
        >
          {t('pages.download.web.cta')}
        </CtaButton>
      }
      visual={
        <Image
          src={heroProductPreview}
          alt={t('pages.download.web.imageAlt')}
          className={styles.shot}
          sizes="(max-width: 1024px) 100vw, 620px"
          priority
        />
      }
    />
  );
};

const styles = {
  shot: [
    'relative z-[2] h-auto w-full rounded-[14px] border',
    'border-[#F0F0F0] shadow-[0_20px_50px_rgba(20,30,60,0.08)]',
    'marketing-dark:border-white/10',
    'marketing-dark:shadow-[0_50px_110px_rgba(2,8,30,0.66),0_8px_24px_rgba(0,0,0,0.34)]',
  ].join(' '),
};
